import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ConnectionService } from 'src/app/connection.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { SocketService } from 'src/app/services/socket.service';

@Component({
  selector: 'app-block',
  templateUrl: './block.component.html',
  styleUrls: ['./block.component.css']
})
export class BlockComponent implements OnInit {
  yesterDayBlocks: any;
  latestBlock: any;

  constructor(private conn: ConnectionService, private router: Router,
    private alert: ToastrService, private spinner: NgxSpinnerService, private socketService: SocketService) { }
  blockDetails: any;
  blockseconds: any;
  dep: number = 1

  ngOnInit() {
    setTimeout(()=>
    {
      this.socketBlocks();
      this.yesterDayblockCounts();
    },1000)


  }

  socketBlocks(): any {
    this.socketService.latestBlocks().subscribe((res: any) => {
      if (res == 'latestblocks') {
        this.latestBlockDetails();
        this.blockHistoryDetails();
      }
    });
  }

  blockHistoryDetails() {
    // this.spinner.show()
    this.conn.getUrl('users/getAllBlocks').subscribe((res: any) => {
      this.blockDetails = res.data
    })
  }

  yesterDayblockCounts() {
    this.spinner.show()
    this.conn.postUrl('users/24hrBlock', {}).subscribe((res: any) => {
      this.spinner.hide()
      this.yesterDayBlocks = res.blockData
    })
  }

  latestBlockDetails() {
    this.conn.postUrl('users/dashboard-data', {}).subscribe((res: any) => {
      this.latestBlock = res.data[0].latestBlocks
    })
  }

  copyText(val: string) {
    let selBox = document.createElement('input');
    selBox.value = val;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
    window.scrollTo(0, 0);
    this.alert.success('Copied to the clipboard');
  }
}
